<template>
  <div>
    <div class="nav">
      <img src="../assets/logo.png" alt="" style="margin-right: 85px">
      <p>
        <a href="https://www.icode.org.cn/">{{ $t("nav_home") }}</a>
<!--        <a :href="`https:${this.Go_www}/`" target="_blank">首页</a>-->

      </p>
      <p>
<!--        <a :href="`https:${this.Go_www}/raceCenter`" target="_blank">赛事</a>-->
        <a href="https://www.icode.org.cn/raceCenter">{{ $t("nav_race") }}</a>
      </p>
      <p>
<!--        <a :href="`https:${this.Go_www}/certificate`" target="_blank">证书</a>-->
        <a href="https://www.icode.org.cn/certificate">{{ $t("nav_certificate") }}</a>
      </p>
      <p>
<!--        <a :href="`https:${this.Go_www}/aboutus`" target="_blank">关于我们</a>-->
        <a href="https://www.icode.org.cn/aboutus">{{ $t("nav_about_us") }}</a>
      </p>
      <p>
<!--        <a :href="`https:${this.Go_www}/racePartner`" target="_blank">赛事伙伴</a>-->
        <a href="https://www.icode.org.cn/racePartner">{{ $t("nav_race_partner") }}</a>
      </p>
      <p>
        <a href="javascript:;" style="color:#148bff">{{ $t("nav_ohc") }}</a>
      </p>
    </div>
    <div class="OH-code">
      <section>
        <p class="title">
          <i class="icons"></i>
          <span>{{ $t("ohc_title") }}</span>
          <i class="icons"></i>
        </p>
      </section>
      <section class="OH-code-title">
        <h1 style="font-size:30px;">{{ $t("ohc_subtitle") }}</h1>

        <div class="OH-code-link">
          <a href="https://t.1yb.co/bKCO" target="_blank">
            <span><i class="el-icon-question"></i>{{ $t("ohc_what_is") }}</span>
          </a>
        </div>
      </section>

      <section class="OH-code-content">
        <div
            class="courseBox"
            @mouseover="playBlockyG()"
            @mouseleave="playBlockyJ()"
        >
          <img :src="playBlocky" />
          <ul>
            <li>{{ $t("ohc_blocky_no_code") }}</li>
            <li>{{ $t("ohc_blocky_drag") }}</li>
            <li><b>{{ $t("ohc_blocky_recommend") }}</b></li>
          </ul>
          <button class="blocky" @click="to_OHC(0, 123001, 'OHblocky')">
            {{ $t("ohc_enter_blockly") }}
          </button>
        </div>

        <div
            class="courseBox"
            @mouseover="playPythonG()"
            @mouseleave="playPythonJ()"
        >
          <img :src="playPython" />
          <ul>
            <li>{{ $t("ohc_python_code") }}</li>
            <li>{{ $t("ohc_python_ai") }}</li>
            <li><b>{{ $t("ohc_python_recommend") }}</b></li>
          </ul>
          <button class="py" @click="to_OHC(1, 123002, 'OHpython')">
            {{ $t("ohc_enter_python") }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {
    return {
      Go_www:'',
      // 编程一小时图片
      playBlocky: "",
      playBlockyJPG: require("../assets/images/event/oneHourCode/ohc-blocky.jpg"),
      playBlockyGIF: require("../assets/images/event/oneHourCode/ohc-blocky.gif"),
      playPython: "",
      playPythonJPG: require("../assets/images/event/oneHourCode/ohc-python.jpg"),
      playPythonGIF: require("../assets/images/event/oneHourCode/ohc-python.gif"),
    };
  },

  methods: {
    to_OHC(mode, gameId) {
      try {
        this.$http
          .getAxios("user/enterGame", {
            method: "post",
            data: {
              mode: mode,
              gameId: gameId,
              channel: "tourist",
            },
          })
          .then((res) => {
            var res = res.data;

            if (res.code == "0") {
              let urls = `${process.env.GO_IDE}?highLevel=1&mode=${mode}&game=${gameId}&language=${this.$i18n.locale}&channel=tourist`;
              window.location.href = urls;
            } else if (res.code == "49") {
              this.$notify.error({
                title: this.$t("error_title"),
                message: this.$t("notStart"),
              });
            } else if (res.code == "50") {
              this.$notify.error({
                title: this.$t("error_title"),
                message: this.$t("game_already_closed"),
              });
            } else if (res.code == "122") {
              this.$notify.error({
                title: this.$t("error_title"),
                message: this.$t("ohc_game_not_exist"),
              });
            } else if (res.code == "123") {
              this.$notify.error({
                title: this.$t("error_title"),
                message: this.$t("gameSettingError"),
              });
            } else {
              this.$notify.error({
                title: this.$t("error_title"),
                message: `${this.$t("ohc_error_prefix")}${res.msg}`,
              });
            }
          });
      } catch (error) {
        this.$notify.error({
          title: this.$t("error_title"),
          message: this.$t("ohc_enter_game_error"),
        });
      }
    },

    playBlockyG() {
      this.playBlocky = this.playBlockyGIF;
    },
    playBlockyJ() {
      this.playBlocky = this.playBlockyJPG;
    },
    playPythonG() {
      this.playPython = this.playPythonGIF;
    },
    playPythonJ() {
      this.playPython = this.playPythonJPG;
    },
  },

  mounted() {
    this.playBlockyJ();
    this.playPythonJ();
    I18nUtils.initLanguage(this);
  },
  created() {
    this.Go_www = process.env.GO_WWW
  }
};
</script>

<style lang="scss">
.nav{
  width: 100vw;
  height:85px;
  background: #fff;
  display:flex;
  align-items: center;
  font-size:22px;
  img{
    width: 75px;
    height: 55px;
    margin: 0 20px 0 30px;
  }
  p{
    padding: 0 25px;
    a{
      text-decoration: none
    }
    //a:active{
    //  color: #148bff
    //}
  }
}
.OH-code {
  width: 100vw;
  height: calc(100vh - 85px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;

  section {
    display: flex;
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size:48px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 60px;
    //padding-top: 50px;
    .icons {
      display: block;
      width: 3.125rem;
      height: 3.125rem;
      margin: 0 0.8rem;
      background: url("../assets/img.png") center / contain
      no-repeat;
    }
  }

  &-title {
    flex-direction: column;

    h1 {
      font-size: 2vw;
    }

    a {
      font-size: 1.2vw;
      font-weight: bold;

      &:hover {
        text-decoration: underline;
      }

      i {
        margin-right: 0.3vw;
      }
    }
  }

  &-link {
    margin: 4vh 2vh 2vh;
  }

  &-content {
    flex-direction: row;
    justify-content: center;

    .courseBox {
      position: relative;
      margin: 2vw;
      border: 1px solid #bebebe;
      border-radius: 10px;
      transform: scaleZ(1.1);
      transition: 0.4s ease all;

      &:hover {
        box-shadow: 1px 1px 10px 4px #c1c1c1;
      }

      img {
        width: 20vw;
        height: 25vh;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      ul {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        line-height: 2vw;
        font-size: 0.9vw;
        margin: 1.5vh auto 4vh;
        cursor: default;
      }

      button {
        display: block;
        position: absolute;
        left: 4vw;
        bottom: -3vh;
        width: 12vw;
        height: 5.5vh;
        border: 0;
        border-radius: 1.2vw;
        box-shadow: 0px 2px 8px 2px #c4c4c4;

        color: #fff;
        font-size: 1.3vw;
        font-weight: bold;
        cursor: pointer;
        transition: 0.4s ease all;

        &:hover {
          transform: scale(1.05);
        }
      }

      .blocky {
        background-color: #f59a23;
      }

      .py {
        background-color: #148bff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ohcIndex.vue